import React from 'react';
interface TarjetaProps {
  children: React.ReactNode;
  className?: string;
  as?: 'div' | 'section' | 'article' | 'li';
}
export function Tarjeta({
  children,
  className = '',
  as = 'div'
}: TarjetaProps) {
  const Etiqueta = as;
  return <Etiqueta className={`rounded-2xl border border-linea bg-white p-4 shadow-[0_1px_2px_rgba(17,24,39,0.04)] sm:p-5 ${className}`} data-id="element-430" data-mp="2hpmp8vws9bv4">
      {children}
    </Etiqueta>;
}
export function TituloSeccion({
  children,
  descripcion,
  nivel = 2
}: {
  children: React.ReactNode;
  descripcion?: string;
  nivel?: 1 | 2 | 3;
}) {
  const Etiqueta = `h${nivel}` as unknown as keyof JSX.IntrinsicElements;
  const tamano = nivel === 1 ? 'text-2xl sm:text-3xl' : nivel === 2 ? 'text-lg sm:text-xl' : 'text-base';
  return <div className="mb-3" data-id="element-431" data-mp="2wgc4c9dd7b49">
      <Etiqueta className={`font-bold text-tinta-titulo ${tamano}`} data-id="element-432" data-mp="1p0xnqvrtf4iu">{children}</Etiqueta>
      {descripcion && <p className="mt-1 text-sm text-tinta-sec" data-id="element-433" data-mp="1kyb0l863a7rz">{descripcion}</p>}
    </div>;
}